module.exports = "<ig-layout-two-column></ig-layout-two-column>\n"